import { Status } from "./Status";

export class OrderNumberTypeSmartEnum {
    static Storage = new Status("Storage", 1, "pill--blue");
    static Recalls = new Status("Recalls", 2, "pill--orange");
    static Disposals = new Status("Disposals", 3, "pill--red");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "OrderNumberTypeSmartEnum";
    }
}
